<template>
  <v-form ref="form" @submit.prevent="$emit('submit')">
    <v-row>
      <v-col>
        <h4>General information</h4>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="name"
        >
          <v-text-field
            v-model="sortitionDisplay.name"
            label="Name"
            name="name"
            :error-messages="errors"
            type="text"
          >
          </v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="sortitionId"
        >
          <v-text-field
            v-model="sortitionDisplay.sortitionId"
            label="Sortition Id"
            name="sortitionId"
            :error-messages="errors"
            type="text"
          >
          </v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="order"
        >
          <v-text-field
            v-model="sortitionDisplay.order"
            label="Order"
            name="order"
            :error-messages="errors"
            type="text"
          />
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="logo"
        >
          <v-row>
            <v-col>
              <v-file-input
                v-model="sortitionDisplay.logo"
                label="Logo"
                name="logo"
                :error-messages="errors"
              >
              </v-file-input>
            </v-col>
            <v-col>
              <v-img v-if="logoSrc" :max-width="150" :src="logoSrc"></v-img>
            </v-col>
          </v-row>
        </validation-provider>
        <v-spacer></v-spacer>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="background"
        >
          <v-row>
            <v-col>
              <v-file-input
                v-model="sortitionDisplay.background"
                label="Background"
                name="background"
                :error-messages="errors"
              />
            </v-col>

            <v-col>
              <v-img
                v-if="backgroundSrc"
                :max-width="150"
                :src="backgroundSrc"
              ></v-img>
            </v-col>
          </v-row>
        </validation-provider>
        <v-spacer></v-spacer>
        <h4>Closing times</h4>
        <sortition-weekday-schedule-row
          v-for="(schedule, index) in sortitionDisplay.schedules"
          :key="`weekday-${schedule.weekday}`"
          v-model="sortitionDisplay.schedules[index]"
          :weekday="weekdayIdToWeekdayMap[schedule.weekday]"
          :index="index"
          @copy="onScheduleCopy"
        >
        </sortition-weekday-schedule-row>
      </v-col>
      <v-col>
        <h4>Lottery</h4>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="lotteryId"
        >
          <v-select
            v-model="sortitionDisplay.lotteryId"
            :items="params.lotteries"
            :error-messages="errors"
          />
        </validation-provider>
        <v-spacer></v-spacer>
				<v-spacer></v-spacer>
				<h4>Results</h4>
        <validation-provider
          v-slot="{ errors }"
          :value="sortitionDisplay.resultFields"
          slim
          name="resultFields"
        >
          <v-checkbox
            :error-messages="errors"
            v-for="fillableInput in params.resultFields"
            :key="`fillable-input-${fillableInput.id}`"
            dense
            hide-details
            multiple
            :label="fillableInput.description"
            v-model="sortitionDisplay.resultFields"
            :value="fillableInput.id"
          >
          </v-checkbox>
          <v-messages color="red" :value="errors"></v-messages>
        </validation-provider>
      </v-col>
		</v-row>
		<input type="submit" hidden />
	</v-form>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import SortitionWeekdayScheduleRow from "../sortition/SortitionWeekdayScheduleRow.vue";
import { required } from "vee-validate/dist/rules.js";

extend("required", {
  ...required,
  message: "This field is required"
});

export default {
  name: "SortitionDisplayForm",
  components: {
    ValidationProvider,
    SortitionWeekdayScheduleRow
  },
  model: {
    prop: "sortitionDisplay"
  },
  props: {
    sortitionDisplay: {
      type: Object,
      required: false,
      default: () => ({}),
      description: "The sortition to be manipulated."
    },
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      logoSrc: "",
      backgroundSrc: ""
    };
  },
  computed: {
    weekdayIdToWeekdayMap() {
      return Object.fromEntries(this.params.weekdays.map(w => [w.id, w]));
    }
  },
  methods: {
    onScheduleCopy(payload) {
      const time = payload.time;

      this.sortitionDisplay.schedules.forEach(schedule => {
        this.$set(schedule, "time", time);
      });
    }
  },
  watch: {
    "sortitionDisplay.logo"() {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.logoSrc = reader.result;
      };
      if (this.sortitionDisplay.logo && this.sortitionDisplay.logo.name) {
        reader.readAsDataURL(this.sortitionDisplay.logo);
      } else if (this.sortitionDisplay.logo) {
        this.logoSrc = this.sortitionDisplay.logo.normal.url;
      }
    },
    "sortitionDisplay.background"() {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.backgroundSrc = reader.result;
      };
      if (
        this.sortitionDisplay.background &&
        this.sortitionDisplay.background.name
      ) {
        reader.readAsDataURL(this.sortitionDisplay.background);
      } else if (this.sortitionDisplay.background) {
        this.backgroundSrc =
          this.sortitionDisplay.background.normal.url;
      }
    }
  }
};
</script>

<style scoped></style>
